import React from "react"

export default () => {
  return (
    <div>
      <h3>Below is the CSS Cheatsheet:</h3>
      <p>
        You can use this page as a reference for when you need to lookup a
        certain CSS properties.
      </p>
      <table className="plain-table">
        <tbody>
          <tr>
            <td data-label="Property">//</td>
            <td data-label="Application">This adds a comment to CSS</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              //this is useful for leaving notes
              
              div {
                //color: red;
              }

              /*
              You can also use comments
              for multi-lines.
              Like this!
              */

              </style>
              <div>
                I'm not red due to color being commented out!
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div>I'm not red due to color being commented out!</div>
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: "center" }}>
              <b>SELECTORS</b>
              <br />
              <i>Choose which element(s) to select for styling</i>
            </td>
          </tr>
          <tr>
            <td data-label="Selector">*</td>
            <td data-label="Effects">All Elements</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              * {
                color:red;
              }
              </style>
              <div>Everything is Red!</div>
              <p>Seriously - everything</p>`}
              </pre>
            </td>
            <td data-label="View">
              <div style={{ color: "red" }}>Everything is Red!</div>
              <p style={{ color: "red" }}>Seriously - everything</p>{" "}
            </td>
          </tr>
          <tr>
            <td data-label="Selector">h4</td>
            <td data-label="Effects">All H4 Headings</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              h4 {
                color:red;
              }
              </style>
              <h4>I'm red</h4>
              <h5>h5's aren't red</h5>
              <h4>Since I'm an h4, I'm also red!</h4>`}
              </pre>
            </td>
            <td data-label="View">
              <h4 style={{ color: "red" }}>I'm red</h4>
              <h5>h5's aren't red</h5>
              <h4 style={{ color: "red" }}>Since I'm an h4, I'm also red!</h4>
            </td>
          </tr>
          <tr>
            <td data-label="Selector">.class-name</td>
            <td data-label="Effects">All Elements with Class ".class-name"</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              .class-name {
                color:red;
              }
              </style>
              <div class="class-name">Only I'm red!</div>
              <p>I'm pretty normal...</p>`}
              </pre>
            </td>
            <td data-label="View">
              <div style={{ color: "red" }}>Only I'm red!</div>
              <p>I'm pretty normal...</p>
            </td>
          </tr>
          <tr>
            <td data-label="Selector">#about-me</td>
            <td data-label="Effects">All Elements with ID "about-me"</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              #about-me {
                color:red;
              }
              </style>
              <div id="about-me">Only I'm red!</div>
              <p>I'm pretty normal...</p>`}
              </pre>
            </td>
            <td data-label="View">
              <div style={{ color: "red" }}>Only I'm red!</div>
              <p>I'm pretty normal...</p>
            </td>
          </tr>
          <tr>
            <td data-label="Selector">.class1, .class2, #id1</td>
            <td data-label="Effects">
              Elements with a selector in the comma-separated list
            </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              .class1, .class2, #id1{
                color:red;
              }
              </style>
              <div class="class1">I'm red!</div>
              <div class="class2">Me too!</div>
              <div id="id1">Me three!</div>
              <div id="id2">I'm not in the selection :(</div>`}
              </pre>
            </td>
            <td data-label="View">
              <div style={{ color: "red" }}>I'm red!</div>
              <div style={{ color: "red" }}>Me too!</div>
              <div style={{ color: "red" }}>Me three!</div>
              <div>I'm not in the selection :(</div>
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: "center" }}>
              <b>PROPERTIES</b>
              <br />
              <i>Apply these styles to selected elements</i>
            </td>
          </tr>
          <tr>
            <td data-label="Property">align-content</td>
            <td data-label="Application">
              Alignment of content when using flex
            </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              .parent-div {
                display: flex;
                flex-wrap: wrap;
                align-content: space-around;
                height: 200px;
              }
              </style>
              <div class="parent-div">
                <div>These two divs have space around them. </div>
                <div>Note: it only works if you are using flex-wrap:wrap; </div>
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  display: "flex",
                  alignContent: "space-around",
                  flexWrap: "wrap",
                  height: 200,
                }}
              >
                <div>These two divs have space around them. </div>
                <div>Note: it only works if you are using flex-wrap:wrap; </div>
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">background</td>
            <td data-label="Application">Changes background of element</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                background: red;
              }
              </style>
              <div>
                I have a nice red background!
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div style={{ background: "red" }}>
                I have a nice red background!
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">border</td>
            <td data-label="Application">Sets border for element</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                border: 3px dashed red;
                //use is: thickness, type, color
              }
              </style>
              <div>
                I have a nice dashed red border;
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div style={{ border: "3px dashed red" }}>
                I have a nice dashed red border
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">
              border-bottom, border-top, border-left, border-right
            </td>
            <td data-label="Application">Apply border to only one side</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                border-top: 3px dashed red;
                border-bottom: 3px dashed red;
              }
              </style>
              <div>
                I have a nice dashed red border only on the top and bottom!
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  borderBottom: "3px dashed red",
                  borderTop: "3px dashed red",
                }}
              >
                I have a nice dashed red border only on the top and bottom!
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">border-radius</td>
            <td data-label="Application">Curve the border at the corners </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                border: 1px solid red;
                border-radius: 10px;
              }
              </style>
              <div>
                My border is curved on the corners
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  border: "1px solid red",
                  borderRadius: 10,
                  padding: 5,
                }}
              >
                My border is curved on the corners
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">box-shadow</td>
            <td data-label="Application">Add a shadow to an element</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                box-shadow: 2px 2px 5px #000000;
              }
              </style>
              <div>
                I've got a nice shadow.
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  boxShadow: "2px 2px 5px #000",
                }}
              >
                I've got a nice shadow.
              </div>
            </td>
          </tr>{" "}
          <tr>
            <td data-label="Property">color</td>
            <td data-label="Application">Text color</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                color: red;
              }
              </style>
              <div>
                I'm red!
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  color: "red",
                }}
              >
                I'm red!
              </div>
            </td>
          </tr>{" "}
          <tr>
            <td data-label="Property">cursor</td>
            <td data-label="Application">Cursor icon when hovering element</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                cursor: pointer;
              }
              </style>
              <div>
                If you mouse over me, I look clickable (according to the cursor icon)
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  cursor: "pointer",
                }}
              >
                If you mouse over me, I look clickable (according to the cursor
                icon)
              </div>
            </td>
          </tr>{" "}
          <tr>
            <td data-label="Property">font-family</td>
            <td data-label="Application">The font of this element </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                font-family: 'Courier New';
              }
              </style>
              <div>
                I'm in Courier New font
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  fontFamily: "Courier New",
                }}
              >
                I'm in Courier New font
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">font-size</td>
            <td data-label="Application">Size of font </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                font-size: 7px;
              }
              </style>
              <div>
              I'm pretty small!
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  fontSize: "7px",
                }}
              >
                I'm pretty small!
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">font-weight</td>
            <td data-label="Application">Boldness of the text </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                font-weight: bolder;
              }
              </style>
              <div>
                I'm thicc
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  fontWeight: "bolder",
                }}
              >
                I'm thicc
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">height</td>
            <td data-label="Application">Height of the element </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                height: 100px;
                background: yellow;
              }
              </style>
              <div>
                This div is 100 pixels tall!
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  height: 100,
                  background: "yellow",
                }}
              >
                This div is 100 pixels tall!
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">justify-content</td>
            <td data-label="Application">
              Arranges content horizontally for flex container
            </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              .parent-div {
                display: flex;
                justify-content: space-evenly;
              }
              </style>
              <div class="parent-div">
                <div>1</div>
                <div>2</div>
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <div>1</div>
                <div>2 </div>
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">letter-spacing</td>
            <td data-label="Application">Space between characters </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                letter-spacing: 10px;
              }
              </style>
              <div>
                Spacing out the letters!
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  letterSpacing: 10,
                }}
              >
                Spacing out the letters!
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">line-height</td>
            <td data-label="Application">Line height of text</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                line-height 3;
              }
              </style>
              <div>
              Each line of this text is 3 times higher than normal. You'll really only notice if this spills over into a new line :P 
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  lineHeight: 3,
                }}
              >
                Each line of this text is 3 times higher than normal. You'll
                really only notice if this spills over into a new line :P
              </div>
            </td>
          </tr>{" "}
          <tr>
            <td data-label="Property">margin</td>
            <td data-label="Application">
              Set the top, right, bottom and left margins in one line
            </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                //you can set all sides with margin: 10px;
                //or you can set each side like below
                // it goes top, right, bottom, left
                margin: 10px 25px 33px 1px;
                border: 1px solid black;
              }
              </style>
              <div>
              You can set the margin for all sides at once.
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  margin: "10px 25px 33px 1px",
                  border: "1px solid black",
                }}
              >
                You can set the margin for all sides at once.
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">
              max-height, min-height, max-width, min-width
            </td>
            <td data-label="Application">max/min sizing of element </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                max-height: 100px;
                min-height: 50px;
                max-width: 80px;
                min-width: 40px;
              }
              </style>
              <div>
              This box has a variable height/width, but is constrained by the mins and maxes
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  maxHeight: 70,
                  minHeight: 20,
                  maxWidth: 400,
                  minWidth: 200,
                  border: "1px solid black",
                  overflow: "hidden",
                }}
              >
                This box has a variable height/width, but is constrained by the
                mins and maxes
              </div>
            </td>
          </tr>{" "}
          <tr>
            <td data-label="Property">opacity</td>
            <td data-label="Application">
              Transparency of an element from 0-1{" "}
            </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                opacity: 0.5;
                background: yellow;
              }
              </style>
              <div>
              This div is slightly transparent
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  opacity: 0.5,
                  background: "yellow",
                }}
              >
                This div is slightly transparent
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">padding</td>
            <td data-label="Application">
              Space between the element border and content
            </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                //you can set all sides with padding: 10px;
                //or you can set each side like below
                // it goes top, right, bottom, left
                padding: 10px 25px 33px 1px;
                border: 1px solid black
              }
              </style>
              <div>
              You can set the padding for all sides at once.
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  padding: "10px 25px 33px 1px",
                  border: "1px solid black",
                }}
              >
                You can set the padding for all sides at once.
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">position</td>
            <td data-label="Application">
              Positioning options: absolute, fixed, relative, static
            </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              //To use absolute, you must have a parent div with position: relative;
              //This is because the absolute child is positioned to the 'relative' parent.
              .parent {
                position: relative;
                height: 200px;
              }
              .child {
                position: absolute;
                bottom: 0;
                right: 0;
              }
              </style>
              <div class="parent">
              <div class="child">
              bottom left :)
              </div>
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  position: "relative",
                  height: 200,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                  }}
                >
                  bottom left :)
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">text-align</td>
            <td data-label="Application">Horizontal alignment of text</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                text-align: center
              }
              </style>
              <div>
              This text is centered
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  textAlign: "center",
                }}
              >
                This text is centered
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">width</td>
            <td data-label="Application">Width of an element </td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              div {
                width: 50%;
                //you can also use px sizes e.g. width: 150px;
                background: yellow;
              }
              </style>
              <div>
              This div is only 50% of it's parent!
              </div>`}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  width: "50%",
                  background: "yellow",
                }}
              >
                This div is only 50% of it's parent!
              </div>
            </td>
          </tr>
          <tr>
            <td data-label="Property">z-index</td>
            <td data-label="Application">Order of elements if stacked</td>
            <td data-label="Code">
              <pre>
                {`
              <style>
              .parent {
               position: relative;
               height: 100px;
              }
              .child-top {
                z-index: 10;
                background: yellow;
                position: absolute;
                height: 80px;
              }
              .child-bottom {
                z-index: 9;
                background: orange;
                position: absolute;
                top: 20px;
              }
              </style>
              <div class="parent">
                <div class="child-top">
                  This div is on top
                </div>
                <div class="child-bottom">
                  This div is under the other
                </div>
              </div>
            `}
              </pre>
            </td>
            <td data-label="View">
              <div
                style={{
                  position: "relative",
                  height: 100,
                }}
              >
                <div
                  style={{
                    zIndex: "10",
                    height: "80px",
                    background: "yellow",
                    position: "absolute",
                  }}
                >
                  This div is on top
                </div>
                <div
                  style={{
                    zIndex: "9",
                    background: "orange",
                    position: "absolute",
                    top: 20,
                  }}
                >
                  This div is under the other
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
